import { render, staticRenderFns } from "./MainBatteryItem.vue?vue&type=template&id=2088047c&scoped=true"
import script from "./MainBatteryItem.vue?vue&type=script&lang=js"
export * from "./MainBatteryItem.vue?vue&type=script&lang=js"
import style0 from "./MainBatteryItem.vue?vue&type=style&index=0&id=2088047c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088047c",
  null
  
)

export default component.exports